import { type FC } from 'react';
import { ListItem, type ListItemProps } from '@chakra-ui/react';

export interface UiListItemProps extends ListItemProps {}

export const UiListItem: FC<UiListItemProps> = ({ children, ...props }) => {
  return <ListItem {...props}>{children}</ListItem>;
};
